<template>
    <div class="roleContainer">
        <el-row v-has="'role:select'">
            <el-col :span="5">
                <el-tree :data="permissions"
                         show-checkbox
                         node-key="id"
                         ref="tree"
                         default-expand-all>
                    <span slot-scope="{node, data}">
                        <span>
                            <i :class='node.data.icon'></i>  &nbsp;&nbsp;{{ node.label }}
                            <span class="p" v-if="node.data.permissionsType == 1">(目录)</span>
                            <span class="m" v-else-if="node.data.permissionsType == 2">(菜单)</span>
                            <span class="b" v-else>(按钮)</span>
                        </span>
                    </span>
                </el-tree>

            </el-col>
            <el-col :span="2">
                <div class="middle-menu">
                    <el-button size="small" type="primary" @click="updateCheckedKeys">更新菜单</el-button>
                    <el-button size="small" type="primary" @click="addRole">添加角色</el-button>
                </div>

            </el-col>
            <el-col :span="17">
                <transition name="el-zoom-in-center">
                    <el-table
                            :data="tableData"
                            v-show="show"
                            style="width: 100%"
                            stripe
                            border
                            highlight-current-row
                            @row-click="rowSelect"
                            element-loading-text="正在加载数据">
                        <el-table-column
                                label="序号"
                                prop="roleId"
                                align="center"
                                width="50">
                        </el-table-column>
                        <el-table-column
                                label="角色名称"
                                prop="roleName"
                                align="center">
                        </el-table-column>
                        <el-table-column
                                label="角色描述"
                                prop="roleDesc"
                                align="center">
                        </el-table-column>
                        <el-table-column label="角色开关"  align="center">
                            <template slot-scope="scope">
                                <el-switch
                                        v-model="scope.row.status"
                                        active-value="0"
                                        inactive-value="1"
                                        :disabled="scope.row.roleName=='admin'"
                                        @change="changeSwitch(scope.row)">
                                </el-switch>
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="操作"
                                align="center">
                            <template slot-scope="scope">
                                <el-button
                                        size="mini"
                                        type="danger"
                                        icon="el-icon-delete"
                                        plain
                                        @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </transition>
                <el-row>
                    <el-col :span="24">
                        <el-pagination
                                class="pagination"
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page.sync="paginations.page_index"
                                :page-sizes="paginations.page_sizes"
                                :page-size="paginations.page_size"
                                :layout="paginations.layout"
                                :total="paginations.total">
                        </el-pagination>
                    </el-col>
                </el-row>
            </el-col>
        </el-row>
        <!-- 弹框页面 -->
        <add-role :dialog='dialog' :formData="formData" @result='reserve'></add-role>
    </div>
</template>

<script>
    import { getRoleAll,getPermissionsAll,setMenuTree,updateRoleMenuTree,swichRole,delRole } from "@/api/index";
    import AddRole from "../../components/role/AddRole.vue"

    export default {
        components:{
            AddRole
        },
        data() {
            return {
                paginations:{
                    page_index: 1,//当前位于哪页
                    total: 0,//总数
                    page_size: 5,//每页显示多少条
                    page_sizes: [5 ,10 ,20],//下拉选择
                    layout: 'total, sizes, prev, pager, next, jumper'
                },
                formData:{
                    roleName: '',
                    roleDesc: '',
                    status: '1'
                },
                dialog: {
                    show: false,
                    title: "添加",
                    clickModal: false,
                    pressEscape: true
                },
                permissions: [],
                tableData:[],
                show: false,
                selectRow: {}
            }
        },
        methods: {
            addRole(){
                this.dialog.show = true;
            },
            updateCheckedKeys() {
                if(this.selectRow.id == null){
                    this.$message({
                        showClose: true,
                        message: "未选择角色,无法修改",
                        type: 'error'
                    })
                    return
                }
                let checkedKeys = this.$refs.tree.getCheckedKeys()
                this.$confirm("此操作需要用户重新登录生效", '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    updateRoleMenuTree({
                        checkedKeys: checkedKeys.join(","),
                        roleId: this.selectRow.id
                    }).then(res => {
                        if (res.success == true) {
                            this.$message({
                                type: 'success',
                                message: '修改成功!'
                            });
                        }else{
                            this.$message({
                                showClose: true,
                                message: res.message,
                                type: 'error'
                            })
                        }
                    });
                }).catch(() => {

                });

            },
            changeSwitch(row){
                let str = "此操作将此权限用户无法正常使用"
                if( row.status === "0"){
                    str = "此操作将此权限用户恢复正常使用"
                }
                this.$confirm(str, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    swichRole({
                        status: this.selectRow.status,
                        roleId: this.selectRow.id
                    }).then(res => {
                        if (res.success == true) {
                            this.$message({
                                type: 'success',
                                message: '修改成功!'
                            });
                        }else{
                            if(row.status === "0"){
                                row.status = "1"
                            }else{
                                row.status = "0"
                            }
                            this.$message({
                                showClose: true,
                                message: res.message,
                                type: 'error'
                            })
                        }
                    });
                }).catch(() => {
                    if(row.status === "0"){
                        row.status = "1"
                    }else{
                        row.status = "0"
                    }
                });
            },
            rowSelect(row, event, column){
                this.selectRow = row
                setMenuTree(row).then(res => {
                    if (res.success == true) {
                        this.$refs.tree.setCheckedKeys(res.result);
                    }else{
                        this.$message({
                            showClose: true,
                            message: res.message,
                            type: 'error'
                        })
                    }
                });
            },
            handleDelete(index, row){
                if(row.roleId === 1 || row.roleName === 'admin'){
                    this.$message({
                        showClose: true,
                        message: "超级管理员角色无法删除",
                        type: 'error'
                    })
                    return
                }
                this.$confirm("角色删除会导致该角色用户无法登录,您确定要删除角色吗?", '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    delRole(row.roleId).then(res => {
                        if (res.success == true) {
                            this.$message({
                                showClose: true,
                                message: '删除成功',
                                type: 'success'
                            })
                            this.getRoleAll()
                        }else{
                            this.$message({
                                showClose: true,
                                message: res.message,
                                type: 'error'
                            })
                        }
                    });
                }).catch(() => {

                });
            },
            getRoleAll(){
                let that = this
                getRoleAll({
                    pageIndex: this.paginations.page_index,
                    size: this.paginations.page_size
                }).then(res => {
                    if (res.success == true) {
                        that.tableData = res.result.list
                        this.paginations.total = res.result.total
                    }else{
                        this.$message({
                            showClose: true,
                            message: res.message,
                            type: 'error'
                        })
                    }
                });
            },
            getPermissionsAll(){
                let that = this
                getPermissionsAll({}).then(res => {
                    if (res.success == true) {
                        that.permissions = res.result
                    }else{
                        this.$message({
                            showClose: true,
                            message: res.message,
                            type: 'error'
                        })
                    }
                });
            },
            reserve: function(val){
                this.dialog.show = false
                if(val === 'update'){
                    this.getRoleAll()
                    this.formData = {
                        roleName: '',
                        roleDesc: '',
                        status: '0'
                    }
                }
            },
            handleSizeChange(val) {
                this.paginations.page_size = val
                this.getRoleAll()
            },
            handleCurrentChange(val) {
                this.paginations.page_index = val
                this.getRoleAll()
            }
        },
        created(){
            this.getRoleAll()
            this.getPermissionsAll()
        },
        mounted() {
            this.show = true
        }
    }
</script>
<style lang="scss">
    
    .roleContainer{
        background-color: #FFFFFF;
        padding: 16px;
        margin: 20px;
        border-radius: 10px;
        -webkit-box-shadow:0px 3px 3px #c8c8c8;
        -moz-box-shadow:0px 3px 3px #c8c8c8;
        box-shadow:0px 3px 3px #c8c8c8;

        .el-table--enable-row-hover .el-table__body tr:hover>td{
            background-color: #ECF5FF;
        }

         .el-tree-node.is-current > .el-tree-node__content {
            background-color: #c2d6ea !important;
        }
        .parentName{
            font-size: 15px;
            font-weight: bold;
            color: red;
        }
        .p{
            font-size: 1px;
            color: #E6A23C;
        }
        .m{
            font-size: 1px;
            color: #67C23A;
        }
        .b{
            font-size: 1px;
            color: #409EFF;
        }
        .middle-menu .el-button+.el-button{
            margin-top: 20px;
            margin-left: 0px;
        }
        .pagination{
            margin-top: 10px;
            float: right;
        }
    }

</style>
